import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
    getOrganizationMembersApiV1OrganizationsOrgIdMembersGet,
    removeMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDelete,
} from '@/common/api/client/sdk.gen'
import { useCurrentOrg } from '../../org/model'

const getAllMembers = async (org_id: string) => {
    const res = await getOrganizationMembersApiV1OrganizationsOrgIdMembersGet({ path: { org_id } })
    return res.data!
}

const deleteMember = async (org_id: string, user_id: string) => {
    const res = await removeMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDelete({
        path: { org_id, user_id },
    })
    return res.data!
}

export const useOrgMembers = () => {
    const { data: currentOrg, isLoading: currentOrgLoading } = useCurrentOrg()

    const {
        data: orgMembers,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['org_members', currentOrg?.id],
        queryFn: () => getAllMembers(currentOrg?.id ?? ''),
        enabled: !!currentOrg,
    })

    return { orgMembers, currentOrg, isLoading: currentOrgLoading || isLoading, error }
}

export const useRemoveMember = () => {
    const queryClient = useQueryClient()
    const { data: currentOrg } = useCurrentOrg()

    return useMutation({
        mutationFn: (user_id: string) => deleteMember(currentOrg?.id ?? '', user_id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['org_members', currentOrg?.id] })
        },
    })
}
